import { useQuery } from '@apollo/client';
import { I18n, T } from '../../../utils/I18n/I18n';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUserContext } from '../../../context/UserContext';
import { IS_CUSTOMER_SUBSCRIBED } from '../../../screens/PersonalAreaScreen/queriesPersonalArea';
import Button from '../../UI/Button/Button';
import AddressPresentation from './AddressPresentation';
import './PersonalAreaPersonalData.scss';

const PersonalAreaPersonalData = () => {
  const { user } = useUserContext();

  const [isSubscribed, setIsSubscribed] = useState(false);
  const { firstname, lastname, email, id, addresses } = user || {};
  const { data, loading, refetch } = useQuery(IS_CUSTOMER_SUBSCRIBED, {
    skip: !user,
  });

  useEffect(() => {
    if (data && data.isSubscribed) {
      setIsSubscribed(data.isSubscribed.is_subscribed);
      refetch();
    }
  }, [data]);

  let shippingAddress;
  let billingAddress;
  if (addresses) {
    shippingAddress = addresses.filter(address => address.default_shipping === true)[0];
    billingAddress = addresses.filter(address => address.default_billing === true)[0];
  }

  return (
    <I18n>
      {t => (
        <div className="profile">
          <span className="personal-area-title">
            <T id="personalData.profile" />
          </span>
          <p className="profile__headers">
            <T id="personalData.profileInfo" />
          </p>
          <div className="profile__contact">
            <div className="profile__contact-details  mr-auto">
              <p className="mini-headers">
                <T id="personalData.contactInfo" />
              </p>
              <div className="profile__user-data">
                <p>{firstname ? `${firstname} ${lastname}` : t('personalData.loading')}</p>
                <p>{email || t('personalData.loading')}</p>
              </div>
              <Link to="/customer/account/edit/">
                <Button text={<T id="personalData.edit" />} type="button" trait="profile" />
              </Link>
              <Link to="/customer/account/edit/">
                <Button text={<T id="personalData.editPassword" />} type="button" trait="profile" />
              </Link>
            </div>

            <div className="profile__newsletter mr-auto">
              <p className="mini-headers">
                <T id="personalData.newsletter" />
              </p>
              {loading && (
                <p className="profile__user-data">
                  <T id="personalData.newsletterStatus" />
                </p>
              )}
              {!isSubscribed && (
                <p className="profile__user-data">
                  <T id="personalData.newsletterStatus" />
                </p>
              )}
              {isSubscribed && (
                <p className="profile__user-data">
                  <T id="newsletter.subscribed" />
                </p>
              )}
              <Link to="/customer/account/newsletter/">
                <Button text={<T id="personalData.edit" />} type="button" trait="profile" />
              </Link>
            </div>
          </div>

          <div className="profile__address">
            <div className="profile__address-info">
              <span className="profile__headers">
                <T id="personalData.address" />
              </span>
              <Link to="/customer/account/address">
                <span>
                  <T id="personalData.editAddresses" />
                </span>
              </Link>
            </div>
            <div className="profile__addresses">
              {billingAddress ? (
                <AddressPresentation address={billingAddress} addressType="naplatu" />
              ) : (
                <div className="profile__adresses_no-info mr-auto">
                  <strong className="box-title">
                    <span>
                      <T id="personalArea.currentBillingAddress" />
                    </span>
                  </strong>
                  <p className="profile__address-no-info">
                    <T id="personalData.noBillingAddress" />
                  </p>
                  <Link to="/customer/account/address/">
                    <Button text={<T id="personalData.editAddress" />} type="button" trait="profile" />
                  </Link>
                </div>
              )}

              {shippingAddress ? (
                <AddressPresentation address={shippingAddress} />
              ) : (
                <div className="profile__adresses_no-info mr-auto">
                  <strong className="box-title">
                    <span>
                      <T id="personalArea.currentShippingAddress" />
                    </span>
                  </strong>
                  <p className="profile__address-no-info">
                    <T id="personalData.noShippingAddress" />
                  </p>
                  <Link to="/customer/account/address/">
                    <Button text={<T id="personalData.editAddress" />} type="button" trait="profile" />
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </I18n>
  );
};

export default PersonalAreaPersonalData;
